import React from 'react';
import { StyledTab } from './Tab.styles';
import { TabProps } from './Tab.types';

const Tab: React.FC<TabProps> = ({ active, disabled, label, value, width, children, ...props }) => {
  return (
    <StyledTab
      active={active}
      disabled={disabled}
      value={value}
      label={label}
      width={width}
      {...props}
    >
      {label || children}
    </StyledTab>
  );
};

export default Tab;
